



import { Close, DateRange } from '@mui/icons-material'; // Import Close icon and DateRange icon
import { Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify'; // Correct import for ToastContainer and toast
import 'react-toastify/dist/ReactToastify.css'; // Import CSS for Toastify

const CampaignsModal = ({ userId, onClose }) => {  
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(true);  // Automatically open the modal when the component mounts
  const [selectedCampaign, setSelectedCampaign] = useState(null); // To store selected campaign id

  const brandId = localStorage.getItem('brandID'); //

  useEffect(() => {
    console.log("Received userId in CampaignsModal:", userId); // Log userId

    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          ` http://localhost:8000/brand/getMyCampaigns/${brandId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        const data = await response.json();
        if (data.success) {
          setCampaigns(data.data); // Set campaigns in state
        } else {
          console.error('Failed to fetch campaigns');
        }
      } catch (err) {
        console.error('Error fetching campaigns:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, [userId]);  // Re-fetch campaigns every time userId changes

  const handleCampaignSelect = (campaignId) => {
    // Allow only one campaign to be selected
    setSelectedCampaign(campaignId === selectedCampaign ? null : campaignId);
  };



const handleInviteClick = async (campaignId) => {
    if (!campaignId) {
      toast.error("No campaign selected!"); // Show error toast if no campaign is selected
      return;
    }
  
    const requestData = {
      userId: userId,          
      campaignId: campaignId, // Send only the selected campaign id
    };
  
    try {
      const response = await fetch('https://server-side-influencer.onrender.com/brand/invite-to-campaign', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        toast.success("Campaign invitation sent successfully!"); // Show success toast on success
      } else {
        // Show the actual error message returned from the API
        toast.error(data.message || "Failed to send invitation!"); // Use data.message from the API response if available
        console.error('Error:', data.message || "Unknown error");
      }
    } catch (error) {
      toast.error("Something went wrong!"); // Show error toast in case of network or other errors
      console.error('Error:', error);
    }
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    onClose(); // Notify the parent (InfluencerDetails3) that the modal is closed
  };

  return (
    <div>
      {/* Toast Container for the notifications */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={true} />

      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          Select a Campaign to invite
          <IconButton 
            edge="end" 
            color="inherit" 
            onClick={handleCloseDialog} 
            aria-label="close" 
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <p>Loading campaigns...</p>
          ) : (
            <div className="campaign-list" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              {campaigns.length > 0 ? (
                campaigns.map((campaign) => (
                  <div key={campaign._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    {/* Left side: Checkbox and Campaign Type sssss*/}
                    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                      <FormControlLabel
                        control={<Checkbox checked={selectedCampaign === campaign._id} onChange={() => handleCampaignSelect(campaign._id)} />}
                        label={campaign.campaignName} // Display campaign type near the checkbox
                      />
                    </div>

                    {/* Right side: Start Date, End Date, and Invite Buttonsssss     */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                        <DateRange sx={{ marginRight: '5px' }} />
                        <span>{new Date(campaign.startDate).toLocaleDateString()} - {new Date(campaign.endDate).toLocaleDateString()}</span>
                      </div>
                      {/* Invite button next to End Date */}
                      <button
  type="button"
  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
  onClick={() => handleInviteClick(campaign._id)}
  disabled={!selectedCampaign || selectedCampaign !== campaign._id}
>
  Invite
</button>

                    </div>
                  </div>
                ))
              ) : (
                <p>No campaigns found.</p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CampaignsModal;
